import { A } from "@solidjs/router";
import { ChevronLeft } from "lucide-solid";
import type { Component } from "solid-js";
import { twMerge } from "tailwind-merge";
import { routerConfig } from "~/solidJs/app/MainApp/models";
import { useLogoNavigation } from "~/solidJs/entities/HeaderMain/hooks/useLogoNavigation";
import { LogoNew } from "~/solidJs/entities/HeaderMain/ui/Logo";

export const Header: Component<{ class?: string }> = (props) => {
	const { handleLogoClick } = useLogoNavigation();

	return (
		<header class={twMerge("z-[1] py-3.5 pl-5", props.class)}>
			<LogoNew onClick={handleLogoClick} />
		</header>
	);
};

export const BackToWorkspaceLink: Component = () => {
	return (
		<A
			href={routerConfig.workspace.absolute}
			class="caption-13-medium flex items-center gap-1 text-text-secondary-v2 no-underline"
		>
			<ChevronLeft size={16} />
			<span>Back to workspace</span>
		</A>
	);
};
